import { TPlatformValue } from '@/types/uploadForm.interface'

export const LANGUAGES = {
	original: 'Original',
	en: 'English',
	ru: 'Russian',
	ar: 'Arabic',
	es: 'Spanish'
}

export const PLATFROMS_LANGUAGES: Record<TPlatformValue, string> = {
	english: 'English',
	arabic: 'Arabic',
	spanish: 'Spanish',
	'main-english': 'English',
	'main-russian': 'Russian'
}

export const PLATFORMS_LABELS: Record<TPlatformValue, string> = {
	english: 'English',
	arabic: 'Arabic',
	spanish: 'Spanish',
	'main-english': 'Main: English',
	'main-russian': 'Main: Russian'
}

export const PLATFORMS_CODES: Record<TPlatformValue, string> = {
	english: 'en',
	arabic: 'ar',
	spanish: 'es',
	'main-english': 'en',
	'main-russian': 'ru'
}

export const DEFAULT_DESCRIPTION: Record<TPlatformValue, string> = {
	english: 'SCRIPT TO FOLLOW',
	spanish: 'GUIÓN A SEGUIR',
	arabic: 'التفاصيل تتبع',
	'main-english': 'SCRIPT TO FOLLOW',
	'main-russian': 'ТЕКСТ ПОСЛЕДУЕТ'
}
